import styled from '@emotion/styled';
import { Modal } from '@lightspeed/flame/Modal';

export const StyledImage = styled('img')`
  animation: hithere 1.5s ease infinite;
  height: 2.25rem;
  width: 2.25rem;
  cursor: pointer;
`;

export const StyledModal = styled(Modal)`
  width: 60%;
  max-width: 550px;
  @media only screen and (max-width: 700px) {
    width: 90%;
  }
`;
